export const chatConstants = {

    FETCH_CHATMESSAGES_REQUEST: 'FETCH_CHATMESSAGES_REQUEST',
    FETCH_CHATMESSAGES_SUCCESS: 'FETCH_CHATMESSAGES_SUCCESS',
    FETCH_CHATMESSAGES_FAILURE: 'FETCH_CHATMESSAGES_FAILURE',

    SEND_CHATMESSAGE_REQUEST: 'SEND_CHATMESSAGE_REQUEST',
    SEND_CHATMESSAGE_SUCCESS: 'SEND_CHATMESSAGE_SUCCESS',
    SEND_CHATMESSAGE_FAILURE: 'SEND_CHATMESSAGE_FAILURE',

    UPDATE_CHATMESSAGES: 'UPDATE_CHATMESSAGES',
    HYDRATE_CHATMESSAGES: 'HYDRATE_CHATMESSAGES',
    RESET_CHATMESSAGES: 'RESET_CHATMESSAGES'

}
